module.exports = __webpack_public_path__ + "img/print.e7689f41.svg";